'use strict';

var templates = require('../templates');
var fobclient = require('..');
var PersonIdentTyp = require('../entity').PersonIdentTyp;

module.exports = function (connection) {
  return {
    byAnmerkungEquals: function byAnmerkungEquals(anmerkung, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdentTyp, 'byAnmerkungEquals', 'anmerkung')(anmerkung, additionalParams);
    },
    byAnmerkungLike: function byAnmerkungLike(anmerkung, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdentTyp, 'byAnmerkungLike', 'anmerkung')(anmerkung, additionalParams);
    },
    byKennungEquals: function byKennungEquals(kennung, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdentTyp, 'byKennungEquals', 'kennung')(kennung, additionalParams);
    },
    byKennungLike: function byKennungLike(kennung, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdentTyp, 'byKennungLike', 'kennung')(kennung, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(PersonIdentTyp, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(PersonIdentTyp, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('personidenttyp')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/personIdentTyp.js
// module id = Zbt1
// module chunks = 0